export enum ConfigurationType {
    PROPERTY = 'PROPERTY',
    MOTOR = 'MOTOR',
    FRONTIER = 'FRONTIER',
}

export enum RoleCode {
    POLICYHOLDER = 'POLICYHOLDER',
    INSURED_PERSON = 'INSURED_PERSON'
}

export enum ConfigurationStatus {
    DRAFT = 'DRAFT',
    ERRORS = 'ERRORS',
    COMPLETED = 'COMPLETED'
}

export enum PropertyElement {
    PROPERTY = 'PROPERTY',
    GARAGE = 'GARAGE',
    EQUIPMENT = 'EQUIPMENT',
    PERSONAL_BELONGING = 'PERSONAL_BELONGING',
    GARDEN_ARCHITECTURE = 'GARDEN_ARCHITECTURE',
}
